import { Button } from 'antd'
import styled from 'styled-components'

const StyledPageActionButton = styled(Button)`
  margin: 5px;
`

export default StyledPageActionButton
